import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { content } from '../../utils/error-content';
import { formError } from '../../utils/form-error';
import { FunctionHandlerService } from '../function-handler/function-handler.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessErrorService {

  constructor(private functionHandler: FunctionHandlerService) { }

  handleError(error: HttpErrorResponse) {
    const codigo: string = error.error?.codigo;
    if(content.hasOwnProperty(codigo)) {
      const errorContent = content[codigo]
      this.functionHandler.handle(errorContent.action, codigo);
    } else if (!formError.hasOwnProperty(codigo)) {
      this.functionHandler.handle('PAGE', 'UNESPECTED');
    }
  }
}
